import React from 'react';

export default function ChatIcon(props) {
  return (
    <svg width='32px' height='32px' viewBox='0 0 32 32' fill='none' {...props}>
      <g id='feedback-unread-32x32'>
        <path
          id='Shape'
          fillRule='evenodd'
          clipRule='evenodd'
          d='M24 8C25.1046 8 26 8.89543 26 10V20C26 21.1046 25.1046 22 24 22H14.999L11.7071 25.2929C11.5508 25.4492 11.3481 25.5484 11.1314 25.5771L11 25.5858C10.4872 25.5858 10.0645 25.1997 10.0067 24.7024L10 24.5858V22H8C6.89543 22 6 21.1046 6 20V10C6 8.89543 6.89543 8 8 8H24ZM14 18H10C9.44772 18 9 18.4477 9 19C9 19.5128 9.38604 19.9355 9.88338 19.9933L10 20H14C14.5523 20 15 19.5523 15 19C15 18.4872 14.614 18.0645 14.1166 18.0067L14 18ZM22 14H10C9.44772 14 9 14.4477 9 15C9 15.5128 9.38604 15.9355 9.88338 15.9933L10 16H22C22.5523 16 23 15.5523 23 15C23 14.4872 22.614 14.0645 22.1166 14.0067L22 14ZM18 10H10C9.44772 10 9 10.4477 9 11C9 11.5128 9.38604 11.9355 9.88338 11.9933L10 12H18C18.5523 12 19 11.5523 19 11C19 10.4872 18.614 10.0645 18.1166 10.0067L18 10Z'
          fill='currentColor'
        />
      </g>
    </svg>
  );
}
